import React, { useEffect, useState } from "react";
import { Formik, Field, ErrorMessage, Form } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPostsById } from "../../../../redux/posts/action";
import { ApplyForJob } from "../../../../redux/job/action";
import { handleKeyDown, handlePriceKeyDown } from "../../../Common/FewCommonMethods";
import { descriptionvalidation } from "../../../Common/commonvalidation";
import AllTypeFilesUpload from "../../../Common/Upload/AllTypeFilesUpload";
import AsteriskLabel from "../../../Common/AsteriskLabel";

const JobApplyForm = () => {
  const [loading, setLoading] = useState(false);
  const laung = localStorage.getItem("laung") || "en";
  const [lan, setLan] = useState(laung);
  const [work_sample, setWork_sample] = useState();
  const path = "Assets/scss/FindWork.module.scss";
  const { id } = useParams();
  const posts = useSelector(({ posts: { postbyid } }) => postbyid);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPostsById(id));
  }, [dispatch, id]);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const navigate = useNavigate();

  const initialValues = {
    message: "",
    price: "",
    files: null,
  };

  const validationSchema = Yup.object().shape({
    message: descriptionvalidation,
    price: Yup.number().required("Proposed price is required").moreThan(0, "Price must be greater than 0"),
    // files: Array.isArray(work_sample?.files) ? "" : Yup.mixed().required('A file is required')
  });

  const handleSubmit = (values) => {
    const data = {
      ...values,
      files: work_sample?.files,
      post_id: posts.id,
      type: 3,
      url: `/${lan}/praposedsuccessful`,
    };
    dispatch(ApplyForJob(data, setLoading, navigate));
  };

  useEffect(() => {
    setWork_sample(work_sample);
  }, [work_sample]);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formik) => (
        <Form>
          <h6>Cover letter</h6>
          <div className="form-group">
            <label>Your message <AsteriskLabel/></label>
            <Field
              as="textarea"
              className="form-control"
              name="message"
              placeholder="Enter your message"
            />
            <ErrorMessage name="message" component="div" className="error" />
          </div>

          <h6>Craft your proposal</h6>
          <div className="row">
            <div className="col-md-6 form-group">
              <label>
                Enter proposed price in {" "} 
                {posts?.hiring_type == 1 ? "hour" : "month"} <AsteriskLabel/>
              </label>
              <Field
                className="form-control"
                name="price"
                min="1"
                placeholder="Enter price in $"
                onKeyDown={handlePriceKeyDown}
              />
              <ErrorMessage name="price" component="div" className="error" />
            </div>
          </div>

          <h6>Attachment (If any)</h6>
          <div>
            <AllTypeFilesUpload
              setWork_sample={setWork_sample}
              selectedfiles={work_sample?.files}
            />
            <ErrorMessage name="file" component="div" className="error" />
          </div>

          <div className="submit-btn">
            <button type="button" onClick={() => navigate(-1)} className="btn">
              Cancel
            </button>
            <button type="submit" className="btn post-btn">
              Send offer
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                alt=""
              />
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default JobApplyForm;
